module.exports = __webpack_public_path__ + "static/Pets_Build_My_Book-10e339394cef5d5cb4008d5da1f33f8d.jpg";